import React, { useEffect } from 'react';
import './index.css'; 
import { Route, Routes, Outlet, useLocation, Navigate } from 'react-router-dom';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

// Auth & Admin Pages
import LoginPage from './pages/auth/LoginPage';
import AdminLogin from './Admin/pages/AdminLogin'; // Admin Login Page

// Buyer pages
import BuyerProfile from './pages/buyer/BuyerProfile';
import CategoryPage from './componants/CategoryPage';
import FullPageLayout from './componants/FullPageLayout';
import CategoryGrid from './componants/CategoryGrid';
import AboutB2Bhaart from './componants/AboutB2Bhaart';
import TrustPage from './componants/TrustPage';

// Contexts
import { UserProvider } from './contexts/UserContext';
import { CartProvider } from './componants/CartContext';
import Header from './componants/Header';
import AdLayout from './componants/AdLayout';
import PromoCategoryBanners from './componants/PromoCategoryBanners';
import BestsellersSection from './componants/BestsellersSection';
import Footer from './componants/Footer';
import CartPage from './componants/CartPage';
import PowerToolsPage from './componants/PowerToolsPage';
import MedicalSuppliesCards from './componants/MedicalSuppliesPage';
import WriteReviewPage from './componants/WriteReviewPage';
import FAQPage from './componants/FAQPage';
import SellerLayout from './SallerAdmin/componants/SellerLayout';
import SellerDashboard from './SallerAdmin/pages/SellerDashboard';
import UserProfilePage from './SallerAdmin/pages/Profile/UserProfilePage';
import BusinessProfilePage from './SallerAdmin/pages/Profile/BusinessProfilePage';
import BankDetailsPage from './SallerAdmin/pages/Profile/BankDetailsPage';
import LeadsPage from './SallerAdmin/pages/LeadsPage';
import MyProductsPage from './SallerAdmin/pages/ManageProduct/MyProductsPage';
import AddNewProductPage from './SallerAdmin/pages/ManageProduct/AddNewProductPage';
import AdminLayout from './Admin/componants/AdminLayout';
import AdminDashboard from './Admin/pages/AdminDashboard';
import AddCategoryPage from './Admin/pages/AddCategory';
import BannerManagement from './Admin/pages/BannerManagement';
import AddAdPage from './Admin/pages/AddAdPage';
import AboutUs from './componants/AboutUs';
import Press from './componants/Press';
import Blog from './componants/Blog';
import Articles from './componants/Articles';
import ContactUs from './componants/ContactUs';
import CancellationPolicy from './componants/CancellationPolicy';

import PaymentPage from './componants/PaymentOption';
import PopularSearchesPage from './componants/PopularSearches';
import CategoryListPage from './Admin/pages/CategoryListPage';
import EditProductPage from './SallerAdmin/pages/ManageProduct/EditProductPage';
import CategoryProductsPage from './componants/CategoryProductsPage';
import ProductDetailsPage from './componants/ProductDetailsPage';
import AllCategoriesPage from './componants/AllCategoriesPage';
import SellerStorePage from './componants/SellerStorePage';
import ChatPage from './componants/ChatPage';
import SellerListPage from './Admin/pages/SellerListPage';
import UsersManagement from './Admin/pages/UsersManagement';
import BestDealerPage from './Admin/pages/BestDealer';
import Approvals from './Admin/pages/Approvals';
import Subordinates from './Admin/pages/Subordinates';
import { AdminAuthProvider, useAdminAuth } from './Admin/context/AdminAuthContext';
import IssuesPage from './Admin/pages/IssuesPage';
import GiveAccess from './Admin/pages/GiveAccess';
import AddSidebarItem from './Admin/pages/AddSidebarItem';
import BuyerChatHistoryPage from './pages/buyer/BuyerChatHistoryPage';
import AuthPage from './pages/auth/AuthPage';
import ActivityHistory from './componants/ActivityHistory';
import CheckoutPage from './pages/CheckoutPage';
import SellerDetails from './Admin/pages/SellerDetails';
import AdminProductDetails from './Admin/pages/AdminProductDetails';
import OrdersPage from './Admin/pages/OrdersPage';

// --- Protected Route for Admin ---
const AdminProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated } = useAdminAuth(); // Corrected: Using isAuthenticated from context
  
  // Agar admin login nahi hai toh login page par bhej do
  if (!isAuthenticated) {
    return <Navigate to="/frog-side" replace />;
  }
  return <>{children}</>;
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const MainLayout: React.FC = () => {
  return (
    <div className=" bg-gray-100 ">
      <Header /> 
      <main className="flex-grow pt-[110px]">
          <Outlet />
      </main>
      <Footer />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <AdminAuthProvider> {/* Admin Context Wrap kiya */}
      <UserProvider>
        <CartProvider>
          <ScrollToTop /> 
          <Routes>
            {/* PUBLIC & BUYER ROUTES - NO CHANGES HERE */}
            <Route path="/" element={<MainLayout />}> 
              <Route index element={
                  <div className="mx-auto">
                      <AdLayout />
                      <ActivityHistory />
                      <BestsellersSection />
                      
                      <FullPageLayout />
                      <MedicalSuppliesCards />
                      <CategoryGrid />
                      <PowerToolsPage />
                      <AboutB2Bhaart />
                      <TrustPage />
                      <PromoCategoryBanners />  
                  </div>
              } />
              <Route path="/categories/:id" element={<CategoryProductsPage />} />
              <Route path="/product/:id" element={<ProductDetailsPage />} />
              <Route path="/all-categories" element={<AllCategoriesPage />} />
              <Route path="cart" element={<CartPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/login" element={<AuthPage />} />
              <Route path="/buyer/profile" element={<BuyerProfile />} />
              

               <Route path="/buyer/chats" element={<BuyerChatHistoryPage />} />
            <Route path="/buyer/chats/:conversationId" element={<BuyerChatHistoryPage />} />

              <Route path="/write-review" element={<WriteReviewPage />} />
              <Route path="/help" element={<FAQPage />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/press" element={<Press />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/articles" element={<Articles />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/faqs" element={<FAQPage />} />
              <Route path="/cancellation-policy" element={<CancellationPolicy />} />
              {/* <Route path="/track-order" element={<OrdersPage />} /> */}
              <Route path="/payment" element={<PaymentPage />} />
              <Route path="/popular-searches" element={<PopularSearchesPage />} />
              <Route path="/store/:sellerId" element={<SellerStorePage />} />
              <Route path="/chat/:conversationId" element={<ChatPage />} />
            </Route>
            
            {/* SELLER ROUTES - NO CHANGES HERE */}
            <Route path="/seller" element={<SellerLayout />}> 
                <Route index element={<SellerDashboard />} />
                <Route path="dashboard" element={<SellerDashboard />} />
                <Route path="/seller/profile/user" element={<UserProfilePage />} />
                <Route path="/seller/profile/business" element={<BusinessProfilePage />} />
                <Route path="/seller/profile/bank" element={<BankDetailsPage />} />
                <Route path="/seller/leads" element={<LeadsPage />} /> 
                <Route path="/seller/product" element={<MyProductsPage />} /> 
                <Route path="/seller/add-product" element={<AddNewProductPage />} /> 
                <Route path="edit-product/:id" element={<EditProductPage />} />
            </Route>

            {/* --- ADMIN LOGIN ROUTE --- */}
            <Route path="/frog-side" element={<AdminLogin />} />

            {/* --- PROTECTED ADMIN ROUTES --- */}
            <Route 
              path="/frog-side/*" 
              element={
                <AdminProtectedRoute>
                  <AdminLayout />
                </AdminProtectedRoute>
              }
            > 
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="users" element={<UsersManagement />} />
              <Route path="seller-details" element={<SellerDetails />} />
              <Route path="admin-product-details" element={<AdminProductDetails />} />
              <Route path="orders" element={<OrdersPage />} />
              <Route path="best-dealers" element={<BestDealerPage />} />
              <Route path="add-category" element={<AddCategoryPage />} />
              <Route path="category-list" element={<CategoryListPage />} />
              <Route path="banners" element={<BannerManagement />} />
              <Route path="ads/add" element={<AddAdPage />} /> 
              <Route path="sellers" element={<SellerListPage />} />
              <Route path="approval" element={<Approvals />} />
              <Route path="subordinates" element={<Subordinates />} />
              <Route path="issues" element={<IssuesPage />} />
              <Route path="give-access" element={<GiveAccess />} />
              <Route path="add-sidebar-menu" element={<AddSidebarItem />} />
            </Route>

          </Routes>
        </CartProvider>
      </UserProvider>
    </AdminAuthProvider>
  );
}

export default App;